import { render } from "./InvoiceDetails.vue?vue&type=template&id=28142ffd&ts=true"
import script from "./InvoiceDetails.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetails.vue?vue&type=script&lang=ts"

import "./InvoiceDetails.vue?vue&type=style&index=0&id=28142ffd&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__